import React from "react";
// import { bindActionCreators } from 'redux';
import { withAlert } from "react-alert";
import { connect } from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import SignatureCanvas from "react-signature-canvas";
import * as Modal from "react-modal";
import * as htmlToImage from "html-to-image";
import WebFont from "webfontloader";
// import { getAllSitePages } from '../../Actions/actions';
/* Fonts */

WebFont.load({
  google: {
    families: ["Dancing Script", "Cedarville Cursive", "Gloria Hallelujah"],
  },
});

const fonts = [
  {
    family: "'Dancing Script', cursive",
    name: "Collectively",
  },
  {
    family: "'Cedarville Cursive'",
    name: "Collectively",
  },
  {
    family: "'Gloria Hallelujah'",
    name: "Collectively",
  },
];

const customStyles = {
  content: {
    position: "unset",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    // marginRight: '-50%',
    // transform: 'translate(-50%, -50%)',
    margin: "auto",
    maxWidth: "992px",
    overflow: "auto",
    height: "100vh",
    width: "100%",
  },
};

class SignatureComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileError: false,
      file: "",
      changeSignature: 0,
      activeFont: "",
      defaultIndexSign: 1,
      emptyErrorSign: 0,
      signatureVlaue: "",
      data: "",
      fileModalErrorMessage: "",
      fileModalError: false,
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.clear = this.clear.bind(this);
    this.moveBack = this.moveBack.bind(this);
    this.finalSubmitForm = this.finalSubmitForm.bind(this);
    this.myRef = React.createRef();
  }

  capitalLetter = (signatureName) => {
    const splitStr = signatureName.toLowerCase().split(" ");
    for (let i = 0; i < splitStr.length; i++) {
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(" ");
  };

  componentDidUpdate() {
    const { data } = this.state;
    const { defaultValue } = this.props;
    if (defaultValue !== undefined) {
      if (data !== defaultValue) {
        this.setState({
          signatureVlaue: this.capitalLetter(defaultValue),
          data: defaultValue,
        });
      }
    }
  }

  // scrollStep = () => {
  //   if (window.pageYOffset === 0) {
  //     clearInterval(this.state.intervalId);
  //   }
  //   window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  // }

  finalSubmitForm(e) {
    const { file, emptyErrorSign } = this.state;
    e.preventDefault();
    if (file !== "") {
      if (emptyErrorSign === 1) {
        this.setState({
          fileError: true,
        });
      } else {
        this.props.finalSubmitData({ file });
      }
    } else {
      this.setState({
        fileError: true,
      });
    }
    // const intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
    // this.setState({ intervalId });
  }

  sigPad = {};

  clear() {
    this.sigPad.clear();
  }

  trim = () => {
    // const { file } = this.state;
    if (this.sigPad.isEmpty() === false) {
      this.setState({
        changeSignature: 1,
        emptyErrorSign: 0,
        fileModalError: false,
        fileModalErrorMessage: "",
        activeFont: "",
      });
      this.closeModal();
    } else {
      this.setState({
        changeSignature: 0,
        emptyErrorSign: 1,
        fileModalError: true,
        fileModalErrorMessage: "Please add Signature to proceed",
        activeFont: "",
      });
    }
    this.setState(
      {
        file: this.sigPad.getTrimmedCanvas().toDataURL("image/png"),
        fileError: false,
      },
      () => {
        if (this.sigPad.isEmpty() === false) {
          // this.props.finalSubmitData({
          //   file: this.sigPad.getTrimmedCanvas().toDataURL("image/png")
          // });
        }
      }
    );
    // window.scrollTo(0, this.myRef.current.offsetTop);
  };

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  afterOpenModal() {}

  closeModal() {
    const { hide, moveTop } = this.props;
    if (hide === true) {
      this.setState({ modalIsOpen: false });
      moveTop();
    } else {
      this.props.signBack();
    }
  }

  changeFont = (i) => {
    this.setState(() => ({
      activeFont: fonts[i].family,
      fileModalError: false,
      fileModalErrorMessage: "",
    }));
  };

  generate = async () => {
    const { hide, moveTop } = this.props;
    const { signatureVlaue, activeFont } = this.state;
    let options = {
      quality: 0.95,
    };
    if (signatureVlaue !== undefined && activeFont !== undefined) {
      if (signatureVlaue !== "" && activeFont !== "") {
        // const node = document.getElementById("signature");

        // html2canvas(node)
        await htmlToImage
          .toPng(document.getElementById("signature_text"), options)

          .then((canvas) => {
            // if (
            //   empty !== canvas.toDataURL("image/png") &&
            //   empty1 !== canvas.toDataURL("image/png")
            // ) {
            this.setState(
              () => ({
                file: canvas,
                cchangeSignature: 1,
                emptyErrorSign: 0,
                activeFont: "",
                modalIsOpen: false,
                fileError: false,
                fileModalError: false,
                fileModalErrorMessage: "",
              }),
              () => {
                if (hide === false) {
                  this.props.finalSubmitData({
                    file: canvas,
                    signatureVlaue,
                  });
                  this.props.moveTop();
                }
              }
            );
            // }
          });
      } else if (signatureVlaue === "") {
        this.setState({
          fileModalError: true,
          fileModalErrorMessage: "Please type signature to proceed",
        });
      } else if (activeFont === "") {
        this.setState({
          fileModalError: true,
          fileModalErrorMessage: "Please select font for signature to proceed",
        });
      }
    }
    // window.scrollTo(0, this.myRef.current.offsetTop);
    moveTop();
  };

  moveBack() {
    this.props.signBack();
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: this.capitalLetter(e.target.value),
      fileModalError: false,
      fileModalErrorMessage: "",
    });
  };

  render() {
    const {
      fileError,
      file,
      changeSignature,
      activeFont,
      defaultIndexSign,
      signatureVlaue,
      fileModalErrorMessage,
      fileModalError,
    } = this.state;
    const { loader, hide, openModalSignature } = this.props;
    return (
      <span>
        <Modal
          isOpen={hide === true ? this.state.modalIsOpen : openModalSignature}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          style={customStyles}
          contentLabel="test"
          ariaHideApp={false}
          // className="signature-modal"
        >
          <div className="modal-content singh-up-sinagnature-consumer">
            <h4 className="m-hdng">Create your signature</h4>
            <Tabs
              selectedIndex={defaultIndexSign}
              onSelect={(defaultIndexSign1) =>
                this.setState({
                  defaultIndexSign: defaultIndexSign1,
                  fileModalError: false,
                  fileModalErrorMessage: "",
                  activeFont: "",
                })
              }
              className="m-tabs"
            >
              <TabList id="tabs-swipe-demo" className="tabs">
                <Tab className="tab col s12" selectedClassName="active">
                  <a>Draw your signature</a>
                </Tab>
                <Tab className="tab col s6" selectedClassName="active">
                  <a>Type in your signature</a>
                </Tab>
              </TabList>
              <TabPanel className="col s12 t-cn">
                <div id="dys" className="col s12 t-cn active">
                  <div className="tn-head center-align">
                    Draw your signature with your mouse, tablet or smart phone
                  </div>

                  <div className="sgn-area">
                    <SignatureCanvas
                      canvasProps={{ height: 200, className: "sigCanvas" }}
                      ref={(ref) => {
                        this.sigPad = ref;
                      }}
                    />
                    <a className="clear-signature" onClick={this.clear}>
                      Clear
                    </a>
                  </div>

                  <p className="center-align">
                    I agree that this is my signature and I agree this is a
                    legal representation of my signature for all purposes just
                    the same as a pen-and-paper signature.
                  </p>
                  <span className={fileModalError ? "show invalid" : "hide"}>
                    {fileModalErrorMessage}
                  </span>

                  <p className="center-align">
                    <button
                      className="btn waves-effect waves-light primary-btn col s12 m6 offset-m3 profile-insert-signature"
                      onClick={this.trim}
                    >
                      Adopt and Sign
                      <i className="material-icons">arrow_forward</i>
                    </button>
                  </p>
                </div>
              </TabPanel>
              <TabPanel className="col s12">
                <div id="dys" className="col s12 active">
                  <div className="tn-head center-align">
                    Edit your typed signature below and choose a font style you
                    like.
                  </div>

                  <div className="sgn-area sig-outside-main business-signup-signature row">
                    <div id="signature" className=" col s12 m7">
                      <textarea
                        id="signature_text"
                        value={signatureVlaue}
                        style={{
                          fontSize: 35,
                          fontFamily: activeFont,
                          textAlign: "center",
                        }}
                        name="signatureVlaue"
                        onChange={this.onChange}
                      />
                    </div>
                    <div className=" col s12 m5 font-btn">
                      {fonts.map((font, i) => (
                        <button
                          className="col s12 m10 offset-m2 profile-insert-signature"
                          onClick={this.changeFont.bind(this, i)}
                          key={i}
                          style={{ fontFamily: font.family }}
                        >
                          {font.name}
                        </button>
                      ))}
                    </div>
                  </div>

                  <p className="center-align">
                    I agree that this is my signature and I agree this is a
                    legal representation of my signature for all purposes just
                    the same as a pen-and-paper signature.
                  </p>
                  <span className={fileModalError ? "show invalid" : "hide"}>
                    {fileModalErrorMessage}
                  </span>

                  <p className="center-align">
                    <button
                      className="btn waves-effect waves-light col s6 offset-s3 profile-insert-signature primary-btn"
                      onClick={this.generate}
                    >
                      Adopt and Sign
                      <i className="material-icons">arrow_forward</i>
                    </button>
                  </p>
                </div>
              </TabPanel>
            </Tabs>
          </div>
        </Modal>
        <div className={hide === true ? "row" : "hide"}>
          <div className="col s11">
            {/* <div className="row" ref={this.myRef}> */}
            <div className="row">
              <div className="col s12">
                <h5>Setup a Signature for Claims</h5>
                <h6>
                  <strong>
                    Almost done! Set up an E-Signature and give us permission to
                    use it to quickly sign you up for eligible settlements.
                  </strong>
                </h6>
              </div>
            </div>

            <div className="row">
              <form className="col s12">
                <a className="cr-sgn modal-trigger" onClick={this.openModal}>
                  {changeSignature === 0 ? (
                    <span className="signature-text-change">
                      Click here to add signature{" "}
                    </span>
                  ) : (
                    <span className="signature-text-change">
                      Click here to update signature{" "}
                    </span>
                  )}
                  {file ? <img src={file} alt="" /> : null}
                </a>
              </form>
              <span className={fileError ? "show invalid" : "hide"}>
                Please add Signature to proceed.
              </span>

              <div className="col s12 ">
                <div className="divider hdr-bdr " />
              </div>
              <div className="col s12 back-signupbutton">
                <button
                  disabled={loader}
                  className="btn waves-effect waves-light primary-btn col s6 offset-s3 leftb"
                  onClick={this.moveBack}
                >
                  <i className="material-icons">arrow_backward</i>
                  Back
                </button>

                <button
                  disabled={loader}
                  className="btn waves-effect waves-light primary-btn col s6 offset-s3"
                  onClick={this.finalSubmitForm}
                >
                  {!loader ? "Finish" : <CircularProgress size={24} />}
                  <i className="material-icons">arrow_forward</i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </span>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.data,
});

// const mapDispatchToProps = (dispatch) => {
//   bindActionCreators({ getAllSitePages }, dispatch);
// }

export default withAlert(connect(mapStateToProps, null)(SignatureComponent));
